/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".brdrColor[_ngcontent-%COMP%]{border:1px solid #e4e4e4!important}.brdrColor[_ngcontent-%COMP%]:focus{border-color:#1f628e!important}@media only screen and (min-width:1000px){.mobView[_ngcontent-%COMP%]{display:none!important}.webView[_ngcontent-%COMP%]{display:block}}@media only screen and (max-width:1000px){.mobView[_ngcontent-%COMP%]{display:block}.webView[_ngcontent-%COMP%]{display:none!important}}"];
export { styles as styles };

